import TopContent from "../Table/TopContent";
import TableComponent from "../../features/Table/TableComponent.tsx";

import { statuses } from "@/utils/items.ts";
import { SuspenseFallback } from "@/lib/Utils.Components.tsx";
import { useSilaAdminAnimals } from "@/features/Admin/Admin.api.ts";
import RenderCellSilaAnimals from "./Rendercell.SilaAnimals.tsx";
import {
  INITIAL_SILA_ANIMAL_COLUMNS,
  silaAnimalsColumns,
} from "@/features/Animals/SilaAnimals.Columns.ts";

const SilaAnimalsTable = () => {
  const { data, isLoading } = useSilaAdminAnimals();

  if (isLoading) return <SuspenseFallback />;

  return (
    <TableComponent
      INITIAL_VISIBLE_COLUMNS={INITIAL_SILA_ANIMAL_COLUMNS}
      RenderCell={RenderCellSilaAnimals}
      TopContent={TopContent}
      columns={silaAnimalsColumns}
      data={data}
      row={10}
      searchColumns={["gn", "name", "sex", "_id"]}
      setViewProfile={undefined}
      statuses={statuses}
    />
  );
};

export default SilaAnimalsTable;
